import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadATPProducts (params) {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/atp/products/', { params }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async getATPProductDetail (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/products/${id}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async createATPProduct (productId, gtin) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('product', productId)
      formData.append('gtin', gtin)

      axiosInstance.post('/atp/products/', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateATPProduct (productId, description) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('description', description)

      axiosInstance.patch(`/atp/products/${productId}/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async sweepATPProduct (productId, activationStartDate, activationEndDate) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (activationStartDate) formData.append('activated_at__gt', activationStartDate)
      if (activationEndDate) formData.append('activated_at__lt', activationEndDate)

      axiosInstance.post(`/atp/products/${productId}/sweep/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async verifyProduct (productId) {
    return new Promise((resolve, reject) => {
      axiosInstance.post(`/atp/products/${productId}/verify/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async activateProduct (productId) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/atp/products/${productId}/activate/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async deactivateProduct (productId) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/atp/products/${productId}/deactivate/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
